import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import MenuAssociados from '../components/MenuAssociados';
import { CircularProgress } from '@mui/material';

function Logs() {
    const [searcheTermo, setSearchTerm] = React.useState('');
    const [logs, setLogs] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [menuAberto, setMenuAberto] = React.useState(false);
    const navigate = useNavigate();
    const associado = parseInt(sessionStorage.getItem('pesAssociado'));
    const loggedIn = sessionStorage.getItem('loggedIn');
    const token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    
    useEffect(() => {
        if (loggedIn === false || loggedIn === null || loggedIn === undefined) {
          navigate('/Login');
          window.location.reload();
        }
    }, [loggedIn, navigate]);

    // useEffect para buscar os logs
    useEffect(() => {
        setIsLoading(true);
        axios
            .post(
                process.env.REACT_APP_API_URL + '/routes.php?metodo=obtemLogs', null,
                {
                    headers: {
                        "X-Access-Token": token,
                        "Content-Type": "application/json; charset=utf-8",
                    }
                }
            )
            .then((response) => {
                setLogs(response.data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    }, []);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredLogs = logs.filter((log) =>
        log.logModulo.toLowerCase().includes(searcheTermo.toLowerCase()) ||
        log.logTipo.toLowerCase().includes(searcheTermo.toLowerCase()) ||
        log.logCriadoPor.toLowerCase().includes(searcheTermo.toLowerCase()) ||
        new Date(log.logCriadoEm).toLocaleString('en-GB').toLowerCase().includes(searcheTermo.toLowerCase()) //||
        //log.logCriadoEm.toLowerCase().includes(searcheTermo.toLowerCase())
    );
    //identificar a resolução da tela para ajustar o tamanho da tabela
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
        setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div>
                    <MenuAssociados />
                </div>
                <div className='headerMain'>
                    <label className='labelTitulo'>Logs de Atividades</label>
                </div>
                <div className="containerBarraPesquisa">
                    <input
                        className='inputBarraPesquisa'
                        type="text"
                        placeholder="Pesquisar logs..."
                        value={searcheTermo}
                        onChange={handleSearchChange}
                    />
                </div>
                <div className="tabelaPadrao">
                    {isLoading ? (
                        <p><CircularProgress /></p>
                    ) : (
                        windowWidth < 769 ? (
                            filteredLogs.map((log) => (
                                <div style={{borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '15px' }}>
                                    <div key={log.IdLog}>
                                        <p style={{ color: '#000' }}><b>Log:</b> {log.IdLog}</p>
                                        <p style={{ color: '#000', marginTop: '10px' }}><b>Tipo:</b> {log.logTipo}</p>
                                        <p style={{ color: '#000', marginTop: '10px' }}><b>Detalhes:</b> {log.logModulo}</p>
                                        <p style={{ color: '#000', marginTop: '10px' }}><b>Criado Por:</b> {log.logCriadoPor}</p>
                                        <p style={{ color: '#000', marginTop: '10px' }}><b>Criado Em:</b> {new Date(log.logCriadoEm).toLocaleString('en-GB')}</p>
                                    </div>
                                </div>
                            ))
                        ) : (
                        <table>
                            <thead>
                                <tr>
                                    <th className="tdAlignCenter">Log</th>
                                    <th className="tdAlignLeft">Tipo</th>
                                    <th className="tdAlignLeft">Detalhes</th>
                                    <th className="tdAlignLeft">Criado Por</th>
                                    <th className="tdAlignLeft">Criado Em</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredLogs.map((log) => (
                                    <tr key={log.IdLog}>
                                        <td className="tdAlignCenter">{log.IdLog}</td>
                                        <td>{log.logTipo}</td>
                                        <td>{log.logModulo}</td>
                                        <td>{log.logCriadoPor}</td>
                                        <td>{new Date(log.logCriadoEm).toLocaleString('en-GB')}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        )
                    )}
                </div>
            </main>
        </div>
    );
}

export default Logs;